<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="notasEntrada.content"
      class="elevation-1 mt-5 pt-3 rounded-card"
      :loading="loading"
      :server-items-length="notasEntrada.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma nota de entrada encontrada"
      loading-text="Carregando notas de entrada..."
      :options="optionsList"
    >
      <template v-slot:item.descricao="{item}">
      <px-span-tooltip top
                    :text="labelDescricao(item.descricao)"
                    :tooltip="item.descricao"/>
      </template>
      <template v-slot:item.codigoInterno="{ item }">
        <span>{{ item.codigoInterno | naoInformado }}</span>
      </template>
      <template v-slot:item.noEstado="{ item }">
        <px-span-tooltip top
                  :text="labelCfop(item.noEstado)"
                  :tooltip="item.noEstado.descricao"/>
      </template>
      <template v-slot:item.outroEstado="{ item }">
        <px-span-tooltip top
                  :text="labelCfop(item.outroEstado)"
                  :tooltip="item.outroEstado.descricao" />
      </template>
      <template v-slot:item.importacao="{ item }">
        <px-span-tooltip top
                  :text="labelCfop(item.importacao)"
                  :tooltip="item.importacao.descricao"/>
      </template>
      <template v-slot:item.padrao="{ item }">
        <div class="d-flex justify-center">
          <v-checkbox
            v-model="item.padrao"
            @change="updateNotaPadrao(item)"/>
        </div>
      </template>
      <template v-slot:item.options="{ item }" v-if="hasModuleGerencia">
        <v-btn icon
               @click="goToEditNotaEntrada(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon
               @click="onClickDelete(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import TipoNotaEntradaService from './tipo-nota-entrada-service';

export default {
  props: {
    notasEntrada: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código',
          value: 'codigoInterno',
        },
        {
          text: 'Nota de entrada',
          value: 'descricao',
        },
        {
          text: 'CFOP no estado',
          value: 'noEstado',
        },
        {
          text: 'CFOP outro estado',
          value: 'outroEstado',
        },
        {
          text: 'CFOP importação',
          value: 'importacao',
        },
        {
          text: 'Nota padrão',
          value: 'padrao',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
    labelCfop() {
      return cfop => `${cfop.codigo} - ${Vue.filter('truncate')(cfop.descricao, 20)}`;
    },
    labelDescricao() {
      return descricao => Vue.filter('truncate')(descricao, 20);
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    remove(item) {
      this.$emit('remove', item);
    },
    goToEditNotaEntrada(item) {
      this.$router.push({
        name: 'main.configuracoes-notas-entrada.edicao',
        params: {
          id: item.id,
        },
      });
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover esta nota de entrada?',
        'A nota de entrada será removida e esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
    updateNotaPadrao(item) {
      this.loading = true;
      const payload = {
        id: item.id,
        padrao: item.padrao,
      };
      TipoNotaEntradaService.updateTipoNotaEntradaPadrao(payload)
        .then(() => {
          this.$toast('Nota de entrada atualizada com sucesso', { color: 'success' });
          this.$emit('update');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
